<template>
  <div class="w-full px-20 py-6">
    <div class="w-full flex flex-col">
      <div class="w-full w-full__button-block">
        <button
            v-for="n in 9"
            :key="n"
            class="w-button-small  rounded-lg my-1 mx-1 py-2 font-medium text-regal-gray "
            @click="$emit('setAmount', n)"
        >
          <span> {{ n }}</span>
        </button>
      </div>
      <div>
        <button
            class="w-button-l w-full  rounded-lg my-1 mx-1 py-2 font-medium text-regal-gray"
            @click="$emit('setAmount', 10)"
        >
          More
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScreenComponentKeyboard'
}
</script>
<style scoped>
.w-button-small {
  width: calc(33% - 10px);
}

.w-button-l {
  width: calc(100% - 1rem);
}
</style>